// import { useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import { AnimatePresence, motion } from "framer-motion";
// import { ChevronRight, Download, Image as Images, Search, X, ZoomIn } from "lucide-react";
// import { IMG } from "../data/News";

// const GALLERY = [
//   { src: IMG.conf2, title: "National Conclave — Plenary Session", cat: "Conferences" },
//   { src: IMG.hand1, title: "Afghanistan Chamber MoU Exchange", cat: "Partnerships" },
//   { src: IMG.gov1, title: "Pre-Budget Consultation, New Delhi", cat: "Policy" },
//   { src: IMG.solar1, title: "Green Growth & Net-Zero Conclave", cat: "Sustainability" },
//   { src: IMG.factory2, title: "MSME Excellence Awards — Shop Floor Visit", cat: "Industry" },
//   { src: IMG.conf3, title: "IPR & Innovation Summit", cat: "Conferences" },
//   { src: IMG.hand2, title: "Viet Nam Chamber MoU Signing, Mumbai", cat: "Partnerships" },
//   { src: IMG.data1, title: "Digital Infrastructure Forum", cat: "Industry" },
//   { src: IMG.press1, title: "Annual Media Briefing", cat: "Media" },
//   { src: IMG.trade1, title: "Logistics & Trade Facilitation Summit", cat: "Industry" },
//   { src: IMG.edu1, title: "Education & Skills Summit", cat: "Conferences" },
//   { src: IMG.conf1, title: "India–Africa Dialogue Curtain Raiser", cat: "Conferences" },
//   { src: IMG.fin1, title: "Capital Markets Summit", cat: "Industry" },
//   { src: IMG.gov3, title: "States' Investment Roundtable", cat: "Policy" },
//   { src: IMG.solar3, title: "Renewable Energy Site Delegation", cat: "Sustainability" },
//   { src: IMG.hand3, title: "India–Afghanistan Trade Talks", cat: "Partnerships" },
// ];

// const CATS = ["All", "Conferences", "Partnerships", "Policy", "Industry", "Sustainability", "Media"];

// export default function ImageLibrary() {
//   const [cat, setCat] = useState("All");
//   const [query, setQuery] = useState("");
//   const [selected, setSelected] = useState(null);

//   const filtered = useMemo(
//     () =>
//       GALLERY.filter(
//         (g) =>
//           (cat === "All" || g.cat === cat) &&
//           g.title.toLowerCase().includes(query.trim().toLowerCase())
//       ),
//     [cat, query]
//   );

//   return (
//     <main className="bg-cream">
//       {/* hero */}
//       <section className="relative overflow-hidden bg-blush">
//         <div className="absolute inset-0 dot-grid opacity-70" />
//         <div className="absolute -top-24 -right-24 w-[380px] h-[380px] rounded-full bg-gradient-to-bl from-brand/15 to-ember/10 blur-3xl" />
//         <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-12 pb-14 sm:pt-16">
//           <nav className="flex items-center gap-2 text-[12px] font-bold text-mute">
//             <Link to="/newsroom" className="hover:text-brand transition-colors">Home</Link>
//             <ChevronRight className="w-3.5 h-3.5" />
//             <Link to="/newsroom" className="hover:text-brand transition-colors">Newsroom</Link>
//             <ChevronRight className="w-3.5 h-3.5" />
//             <span className="text-brand">Image Library</span>
//           </nav>
//           <motion.p
//             initial={{ opacity: 0, y: 14 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="mt-7 inline-flex items-center gap-2 rounded-full bg-white ring-1 ring-brand/20 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.2em] text-deeprose"
//           >
//             <Images className="w-3.5 h-3.5 text-ember" /> Editorial assets
//           </motion.p>
//           <motion.h1
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.08 }}
//             className="mt-5 font-display font-bold text-[42px] sm:text-[56px] leading-[1.02] tracking-tight text-ink"
//           >
//             Image{" "}
//             <em className="italic text-transparent bg-clip-text bg-gradient-to-r from-crimson via-brand to-ember">
//               Library
//             </em>
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.16 }}
//             className="mt-5 text-[15px] text-ink/60 max-w-2xl font-medium leading-relaxed"
//           >
//             Photographs from ASSOCHAM events and delegations. Images marked below are cleared for
//             editorial use with credit line “Photo: ASSOCHAM”.
//           </motion.p>
//         </div>
//       </section>

//       {/* filters */}
//       <section className="py-10">
//         <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//           <div className="flex flex-wrap items-center justify-between gap-4">
//             <div className="flex flex-wrap gap-2">
//               {CATS.map((c) => (
//                 <button
//                   key={c}
//                   onClick={() => setCat(c)}
//                   className={`px-4 py-2 rounded-full text-[12px] font-extrabold ring-1 transition-all ${
//                     cat === c
//                       ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent shadow-md shadow-brand/25"
//                       : "bg-white text-ink/70 ring-ink/15 hover:ring-brand hover:text-brand"
//                   }`}
//                 >
//                   {c}
//                 </button>
//               ))}
//             </div>
//             <div className="relative w-full sm:w-72">
//               <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-mute" />
//               <input
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 placeholder="Search photos…"
//                 className="w-full rounded-xl bg-white ring-1 ring-ink/10 focus:ring-2 focus:ring-brand outline-none py-2.5 pl-10 pr-3 text-[13px] font-semibold transition-shadow"
//               />
//             </div>
//           </div>

//           {/* grid */}
//           <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
//             <AnimatePresence mode="popLayout">
//               {filtered.map((g, i) => (
//                 <motion.button
//                   layout
//                   key={g.src + g.title}
//                   initial={{ opacity: 0, scale: 0.92 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   exit={{ opacity: 0, scale: 0.92 }}
//                   transition={{ duration: 0.35, delay: i * 0.03 }}
//                   onClick={() => setSelected(g)}
//                   className={`group relative rounded-2xl overflow-hidden ring-1 ring-brand/10 text-left shadow-[0_18px_40px_-24px_rgba(180,35,24,0.4)] ${
//                     i % 5 === 0 ? "col-span-2 row-span-2 h-full min-h-[240px]" : "aspect-[4/3]"
//                   }`}
//                 >
//                   <img
//                     src={g.src}
//                     alt={g.title}
//                     loading="lazy"
//                     className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-110"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-[#1c0f0c]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
//                   <div className="absolute inset-x-0 bottom-0 p-4 translate-y-3 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-400">
//                     <p className="text-white text-[13px] font-bold leading-snug">{g.title}</p>
//                     <p className="text-ember text-[10px] font-extrabold uppercase tracking-[0.16em] mt-1">
//                       {g.cat}
//                     </p>
//                   </div>
//                   <span className="absolute top-3 right-3 w-9 h-9 rounded-xl grid place-items-center bg-white/90 text-brand opacity-0 group-hover:opacity-100 transition-opacity shadow">
//                     <ZoomIn className="w-4 h-4" />
//                   </span>
//                 </motion.button>
//               ))}
//             </AnimatePresence>
//           </div>

//           {filtered.length === 0 && (
//             <p className="py-16 text-center text-[13.5px] text-mute font-semibold">
//               No photos match “{query}” in {cat}.
//             </p>
//           )}
//         </div>
//       </section>

//       {/* lightbox */}
//       <AnimatePresence>
//         {selected && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 z-[90] bg-[#100806]/90 backdrop-blur-sm grid place-items-center p-4 sm:p-8"
//             onClick={() => setSelected(null)}
//           >
//             <motion.figure
//               initial={{ scale: 0.92, y: 24 }}
//               animate={{ scale: 1, y: 0 }}
//               exit={{ scale: 0.92, y: 24 }}
//               transition={{ type: "spring", stiffness: 260, damping: 26 }}
//               className="relative max-w-4xl w-full rounded-3xl overflow-hidden bg-white shadow-2xl"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={selected.src} alt={selected.title} className="w-full max-h-[68vh] object-cover" />
//               <figcaption className="flex items-center justify-between gap-4 px-6 py-4">
//                 <div>
//                   <p className="font-display font-semibold text-[17px] text-ink">{selected.title}</p>
//                   <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-ember mt-1">
//                     {selected.cat} · Photo: ASSOCHAM
//                   </p>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <a
//                     href={selected.src}
//                     target="_blank"
//                     rel="noreferrer"
//                     className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-crimson to-deeprose text-white text-[12px] font-extrabold px-4 py-2.5 shadow-lg shadow-brand/25 hover:brightness-105 transition"
//                   >
//                     <Download className="w-3.5 h-3.5" /> Full size
//                   </a>
//                   <button
//                     onClick={() => setSelected(null)}
//                     className="w-10 h-10 rounded-xl grid place-items-center ring-1 ring-ink/15 text-ink/60 hover:text-brand hover:ring-brand transition-all"
//                   >
//                     <X className="w-4 h-4" />
//                   </button>
//                 </div>
//               </figcaption>
//             </motion.figure>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </main>
//   );
// }




// new new code 





import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import {
  ArrowLeft,
  Calendar,
  ChevronRight,
  Download,
  Eye,
  Image as ImageIcon,
  Layers,
  MapPin,
  Search,
  Sparkles,
  X,
  ZoomIn,
} from "lucide-react";
import { IMG } from "../data/News";

// ============================================================================
// 24 OFFICIAL ASSOCHAM INDIAN EVENT ALBUMS (100% INDIAN CONTEXT & VIKSIT BHARAT)
// ============================================================================
const EVENT_ALBUMS = [
  {
    id: "edu-skill-summit-18",
    title: "18th National Education Leadership & Skill Development Summit 2026",
    cat: "Education & Health",
    date: "July 24, 2026",
    location: "New Delhi",
    description:
      "Aligning higher education frameworks with National Education Policy (NEP) 2020 and empowering India's youth with future-ready skills.",
    banner:
      IMG?.edu1 ||
      "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.edu1 ||
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
        title: "Inaugural Lamp Lighting Ceremony by Hon'ble Dignitaries",
      },
      {
        src:
          IMG?.conf1 ||
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
        title: "Keynote Address on NEP 2020 & Youth Skill Empowerment",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
        title: "Felicitation of Vice-Chancellors & Academic Leaders",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "Industry-Academia Roundtable Discussion",
      },
    ],
  },
  {
    id: "seed-trade-2026",
    title: "INDIA SEED TRADE & INNOVATION SUMMIT 2026",
    cat: "Industry & MSME",
    date: "July 18, 2026",
    location: "New Delhi",
    description:
      "Fostering agricultural self-reliance, high-yield climate-resilient seeds, and bio-technological innovations for Indian farmers.",
    banner:
      IMG?.trade1 ||
      "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.trade1 ||
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1200&q=80",
        title: "Release of ASSOCHAM Agri-Seed Innovation Report",
      },
      {
        src:
          IMG?.gov1 ||
          "https://images.unsplash.com/photo-1591115765373-5207764f72e7?auto=format&fit=crop&w=1200&q=80",
        title: "Address by Ministry of Agriculture & Farmers Welfare Officials",
      },
      {
        src:
          IMG?.hand1 ||
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
        title: "MoU Exchange with Agricultural Research Institutes",
      },
    ],
  },
  {
    id: "mutual-fund-17",
    title: "17th MUTUAL FUND SUMMIT",
    cat: "Finance & Markets",
    date: "July 10, 2026",
    location: "Mumbai",
    description:
      "Driving retail investor inclusion across Tier-2 and Tier-3 Indian cities and strengthening regulatory compliance in capital markets.",
    banner:
      IMG?.fin1 ||
      "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.fin1 ||
          "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
        title: "SEBI Representatives Addressing Fund Managers",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1560523160-754a9e25c68f?auto=format&fit=crop&w=1200&q=80",
        title: "Panel on SIP Growth & Retail Participation in Bharat",
      },
      {
        src:
          IMG?.press1 ||
          "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
        title: "ASSOCHAM Capital Markets Award Presentation",
      },
    ],
  },
  {
    id: "ev-hub-viksit-bharat",
    title: "National Conference on Building India an Electric Mobility Hub for Viksit Bharat",
    cat: "Sustainability & ESG",
    date: "June 28, 2026",
    location: "New Delhi",
    description:
      "Accelerating domestic EV battery manufacturing, nationwide charging infrastructure, and clean transit roadmaps for Viksit Bharat 2047.",
    banner:
      IMG?.solar1 ||
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.solar1 ||
          "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
        title: "Plenary Session on India's Green Mobility Transition",
      },
      {
        src:
          IMG?.solar3 ||
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
        title: "Showcase of Indigenously Developed Electric Drivetrains",
      },
      {
        src:
          IMG?.gov3 ||
          "https://images.unsplash.com/photo-1528605248644-14dfb40fd428?auto=format&fit=crop&w=1200&q=80",
        title: "Delegation Discussion with Ministry of Heavy Industries",
      },
    ],
  },
  {
    id: "business-reform-2026",
    title: "India Business Reform Summit 2026",
    cat: "Policy & Governance",
    date: "June 15, 2026",
    location: "New Delhi",
    description:
      "Advancing Ease of Doing Business, decriminalization of business laws, and single-window statutory clearances across Indian states.",
    banner:
      IMG?.gov1 ||
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.gov1 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "Presidential Address on Industrial Competitiveness",
      },
      {
        src:
          IMG?.gov3 ||
          "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80",
        title: "Release of State Ease of Doing Business Ranking Digest",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1200&q=80",
        title: "Inter-Ministerial Interaction with Industry Captains",
      },
    ],
  },
  {
    id: "women-leading-viksit-bharat",
    title: "Viksit Bharat 2047 Women Leading India Growth Story",
    cat: "Conferences",
    date: "March 27, 2026",
    location: "New Delhi",
    description:
      "Celebrating Nari Shakti in Indian corporate leadership, women-led MSME entrepreneurship, and financial inclusion.",
    banner:
      IMG?.conf2 ||
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1200&q=80",
        title: "Keynote Address on Nari Shakti in Corporate Governance",
      },
      {
        src:
          IMG?.hand2 ||
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1200&q=80",
        title: "Felicitation of Women Founders & CEOs of Bharat",
      },
      {
        src:
          IMG?.conf1 ||
          "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=1200&q=80",
        title: "Panel on Gender Parity in STEM & Industrial Manufacturing",
      },
    ],
  },
  {
    id: "nutribharat-2026",
    title: "ASSOCHAM Nutribharat 2026",
    cat: "Education & Health",
    date: "May 20, 2026",
    location: "New Delhi",
    description:
      "Promoting Shree Anna (Millets), traditional Indian nutrition, functional foods, and preventive healthcare standards.",
    banner:
      IMG?.edu1 ||
      "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.edu1 ||
          "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80",
        title: "Inaugural Exhibition of Indigenous Millets & Superfoods",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
        title: "FSSAI & Scientific Advisory Roundtable",
      },
      {
        src:
          IMG?.press1 ||
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
        title: "Nutribharat Excellence Awards Presentation",
      },
    ],
  },
  {
    id: "esg-conclave-2026",
    title: "India ESG Conclave 2026",
    cat: "Sustainability & ESG",
    date: "May 14, 2026",
    location: "Mumbai",
    description:
      "Empowering Indian corporations with Net-Zero strategies, carbon market readiness, and green financing mechanisms.",
    banner:
      IMG?.solar3 ||
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.solar3 ||
          "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
        title: "Chief Guest Address on India's Panchamrit ESG Goals",
      },
      {
        src:
          IMG?.solar1 ||
          "https://images.unsplash.com/photo-1560523160-754a9e25c68f?auto=format&fit=crop&w=1200&q=80",
        title: "Release of ESG Corporate Disclosure Handbook",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
        title: "Green Finance Leaders Dialogue",
      },
    ],
  },
  {
    id: "fmcg-viksit-bharat",
    title: "FMCG’s Role in Catalysing Growth for Viksit Bharat 2047",
    cat: "Industry & MSME",
    date: "April 29, 2026",
    location: "New Delhi",
    description:
      "Enhancing rural distribution penetration, sustainable packaging, and digital commerce for India's FMCG sector.",
    banner:
      IMG?.trade1 ||
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.trade1 ||
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
        title: "Industry Captains Addressing FMCG Rural Growth",
      },
      {
        src:
          IMG?.factory2 ||
          "https://images.unsplash.com/photo-1581092335397-9583fe92d232?auto=format&fit=crop&w=1200&q=80",
        title: "Sustainable Packaging Showcase by Indian Manufacturers",
      },
      {
        src:
          IMG?.data1 ||
          "https://images.unsplash.com/photo-1531538606174-0f00ff5e21ef?auto=format&fit=crop&w=1200&q=80",
        title: "Supply Chain & Quick-Commerce Transformation Panel",
      },
    ],
  },
  {
    id: "corp-bond-conclave-8",
    title: "8th Annual Conclave on Corporate Bond Market",
    cat: "Finance & Markets",
    date: "April 18, 2026",
    location: "Mumbai",
    description:
      "Deepening domestic debt capital markets, infrastructure financing bonds, and credit enhancement structures.",
    banner:
      IMG?.fin1 ||
      "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.fin1 ||
          "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
        title: "Keynote Address by RBI & SEBI Dignitaries",
      },
      {
        src:
          IMG?.conf1 ||
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80",
        title: "Panel Discussion on Infrastructure Project Bonds",
      },
      {
        src:
          IMG?.press1 ||
          "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80",
        title: "Interaction with Institutional Debt Market Leaders",
      },
    ],
  },
  {
    id: "governance-accountability",
    title: "International Conference on Governance Encompass Steering Corporate Accountability",
    cat: "Policy & Governance",
    date: "April 05, 2026",
    location: "New Delhi",
    description:
      "Best practices in independent directorship, corporate ethics, auditing transparency, and statutory compliance in India.",
    banner:
      IMG?.gov3 ||
      "https://images.unsplash.com/photo-1528605248644-14dfb40fd428?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.gov3 ||
          "https://images.unsplash.com/photo-1528605248644-14dfb40fd428?auto=format&fit=crop&w=1200&q=80",
        title: "Inaugural Address on Transparency & Ethics in India Inc.",
      },
      {
        src:
          IMG?.gov1 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "Felicitation of Corporate Governance Leadership Awardees",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1560523160-754a9e25c68f?auto=format&fit=crop&w=1200&q=80",
        title: "Special Session with Ministry of Corporate Affairs (MCA)",
      },
    ],
  },
  {
    id: "odisha-manufacturing-2025",
    title: "Odisha Manufacturing Conclave 2025",
    cat: "Industry & MSME",
    date: "December 12, 2025",
    location: "Bhubaneswar",
    description:
      "Positioning Odisha as Eastern India's manufacturing powerhouse across steel, aluminum, green hydrogen, and heavy engineering.",
    banner:
      IMG?.factory2 ||
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.factory2 ||
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
        title: "Inaugural Address by Govt of Odisha Representatives",
      },
      {
        src:
          IMG?.trade1 ||
          "https://images.unsplash.com/photo-1581092335397-9583fe92d232?auto=format&fit=crop&w=1200&q=80",
        title: "MoU Signing for Industrial Parks in Eastern India",
      },
      {
        src:
          IMG?.hand3 ||
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
        title: "Interaction with MSME Ancillary Industry Leaders",
      },
    ],
  },
  {
    id: "chemical-conclave-2",
    title: "The Chemical Conclave 2.0",
    cat: "Industry & MSME",
    date: "November 25, 2025",
    location: "Ahmedabad",
    description:
      "Specialty chemicals, green chemistry innovations, safety standards, and export competitiveness for Indian chemical clusters.",
    banner:
      IMG?.data1 ||
      "https://images.unsplash.com/photo-1531538606174-0f00ff5e21ef?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.data1 ||
          "https://images.unsplash.com/photo-1531538606174-0f00ff5e21ef?auto=format&fit=crop&w=1200&q=80",
        title: "Inauguration of Specialty Chemicals Exposition",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1200&q=80",
        title: "Panel on Green Chemistry & Sustainable Synthesis",
      },
      {
        src:
          IMG?.factory2 ||
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
        title: "Award Ceremony for Safety & Industrial Hygiene",
      },
    ],
  },
  {
    id: "food-tech-conference",
    title: "National Conference on Food Tech",
    cat: "Industry & MSME",
    date: "November 10, 2025",
    location: "New Delhi",
    description:
      "Modernizing India's food processing infrastructure, cold-chain logistics, and quality assurance for domestic & global markets.",
    banner:
      IMG?.trade1 ||
      "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.trade1 ||
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1200&q=80",
        title: "Inaugural Session on Mega Food Parks & Processing Tech",
      },
      {
        src:
          IMG?.gov1 ||
          "https://images.unsplash.com/photo-1591115765373-5207764f72e7?auto=format&fit=crop&w=1200&q=80",
        title: "Address by Ministry of Food Processing Industries (MoFPI)",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
        title: "Exhibition of Indian Agri-Tech & Packaging Startups",
      },
    ],
  },
  {
    id: "datacenters-cloud-7",
    title: "7th ASSOCHAM Smart Datacenters & Cloud Infrastructure Summit 2025",
    cat: "Conferences",
    date: "October 22, 2025",
    location: "Hyderabad",
    description:
      "Building AI-ready hyperscale data centers, green energy cooling systems, and sovereign cloud security across India.",
    banner:
      IMG?.data1 ||
      "https://images.unsplash.com/photo-1531538606174-0f00ff5e21ef?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.data1 ||
          "https://images.unsplash.com/photo-1531538606174-0f00ff5e21ef?auto=format&fit=crop&w=1200&q=80",
        title: "Keynote on India as a Global Hyperscale Data Hub",
      },
      {
        src:
          IMG?.conf1 ||
          "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
        title: "Roundtable on AI Compute & Sovereign Cloud Governance",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "ASSOCHAM Technology Leadership Awards",
      },
    ],
  },
  {
    id: "logistics-warehousing-2",
    title: "2nd Edition National Conference on Logistics and Warehousing for Viksit Bharat",
    cat: "Industry & MSME",
    date: "October 08, 2025",
    location: "New Delhi",
    description:
      "PM Gati Shakti National Master Plan implementation, multi-modal connectivity, and automated warehousing across Indian corridors.",
    banner:
      IMG?.trade1 ||
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.trade1 ||
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
        title: "Special Session on PM Gati Shakti & National Logistics Policy",
      },
      {
        src:
          IMG?.gov1 ||
          "https://images.unsplash.com/photo-1560523160-754a9e25c68f?auto=format&fit=crop&w=1200&q=80",
        title: "Felicitation of Multi-Modal Transport Pioneers",
      },
      {
        src:
          IMG?.factory2 ||
          "https://images.unsplash.com/photo-1581092335397-9583fe92d232?auto=format&fit=crop&w=1200&q=80",
        title: "Exhibition on Automation in Indian Warehouses",
      },
    ],
  },
  {
    id: "edu-skill-conference-17",
    title: "17th National Education Leadership and Skill Development Conference",
    cat: "Education & Health",
    date: "September 18, 2025",
    location: "New Delhi",
    description:
      "Digital transformation of Indian universities, apprenticeship integration, and upskilling for Industry 4.0 jobs.",
    banner:
      IMG?.edu1 ||
      "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.edu1 ||
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
        title: "Dignitaries Releasing ASSOCHAM Higher Education Whitepaper",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
        title: "Panel on Vocational Skill Training & Rural Youth Outreach",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "Award Presentation to Outstanding Educational Institutes",
      },
    ],
  },
  {
    id: "power-ministry-roundtable",
    title: "Industry Roundtable discussion with Secretary to Govt of India Ministry of Power",
    cat: "Policy & Governance",
    date: "September 04, 2025",
    location: "Shram Shakti Bhawan, New Delhi",
    description:
      "High-level policy dialogue on electricity distribution reforms, renewable energy purchase obligations, and grid modernization.",
    banner:
      IMG?.gov1 ||
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.gov1 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "Secretary, Ministry of Power, Addressing Industry Delegates",
      },
      {
        src:
          IMG?.gov3 ||
          "https://images.unsplash.com/photo-1528605248644-14dfb40fd428?auto=format&fit=crop&w=1200&q=80",
        title: "Submission of ASSOCHAM Power Sector Memorandum",
      },
      {
        src:
          IMG?.solar3 ||
          "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
        title: "Open Forum on Grid Resilience & Solar Integration",
      },
    ],
  },
  {
    id: "msme-workshop-goa",
    title: "MSME workshop Goa",
    cat: "Industry & MSME",
    date: "August 24, 2025",
    location: "Panaji, Goa",
    description:
      "Capacity building for Goan MSMEs in tourism hospitality, eco-packaging, export documentation, and formal credit access.",
    banner:
      IMG?.hand2 ||
      "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.hand2 ||
          "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80",
        title: "Inauguration of Goa MSME Empowerment Workshop",
      },
      {
        src:
          IMG?.trade1 ||
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1200&q=80",
        title: "Interactive Session with Goan Entrepreneurs & Artisans",
      },
      {
        src:
          IMG?.hand1 ||
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
        title: "Credit Facilitation Camp with Public Sector Banks",
      },
    ],
  },
  {
    id: "financial-inclusion-conclave",
    title: "National Conclave on Financial Inclusion Reforming Today for a Fairer Tomorrow",
    cat: "Finance & Markets",
    date: "August 12, 2025",
    location: "New Delhi",
    description:
      "Expanding PM Jan Dhan Yojana reach, micro-credit for rural women enterprises, and digital public infrastructure (DPI).",
    banner:
      IMG?.fin1 ||
      "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.fin1 ||
          "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
        title: "Keynote Address on Digital Financial Inclusion in Bharat",
      },
      {
        src:
          IMG?.conf1 ||
          "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
        title: "Roundtable on Rural Micro-Finance & Fintech Innovation",
      },
      {
        src:
          IMG?.press1 ||
          "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
        title: "Felicitation of Self-Help Group (SHG) Champions",
      },
    ],
  },
  {
    id: "cfo-summit-awards-3",
    title: "3rd Vibrant Bharat CFO Summit & Awards 2025",
    cat: "Finance & Markets",
    date: "July 28, 2025",
    location: "Mumbai",
    description:
      "Recognizing India's financial leaders for robust treasury management, regulatory governance, and digital finance transformation.",
    banner:
      IMG?.fin1 ||
      "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.fin1 ||
          "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1200&q=80",
        title: "Felicitation of CFO of the Year & Excellence Awards",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1560523160-754a9e25c68f?auto=format&fit=crop&w=1200&q=80",
        title: "CFO Leadership Dialogue on Corporate Growth Strategies",
      },
      {
        src:
          IMG?.press1 ||
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
        title: "Networking Dinner with Financial Sector Leaders",
      },
    ],
  },
  {
    id: "regional-water-summit",
    title: "Regional Water Summit: Transforming Water Management for a Resilient and Sustainable Future",
    cat: "Sustainability & ESG",
    date: "July 14, 2025",
    location: "Bengaluru",
    description:
      "Industrial wastewater recycling, rainwater harvesting mandates, and river basin conservation across Peninsular India.",
    banner:
      IMG?.solar1 ||
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.solar1 ||
          "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
        title: "Inaugural Session on Water Stewardship & Zero Liquid Discharge",
      },
      {
        src:
          IMG?.solar3 ||
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80",
        title: "Showcase of Indian Water Treatment & Desalination Technologies",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "Special Address by Ministry of Jal Shakti Representatives",
      },
    ],
  },
  {
    id: "nutraceutical-summit-10",
    title: "10th Nutraceutical Summit 2025",
    cat: "Education & Health",
    date: "June 25, 2025",
    location: "New Delhi",
    description:
      "Harmonizing Ayurvedic wellness formulations with global nutraceutical standards, preventive health, and FSSAI guidelines.",
    banner:
      IMG?.edu1 ||
      "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.edu1 ||
          "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80",
        title: "Inaugural Lamp Lighting & Release of Nutraceutical Study",
      },
      {
        src:
          IMG?.conf1 ||
          "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
        title: "Scientific Session on Ayurvedic Nutraceutical Innovations",
      },
      {
        src:
          IMG?.press1 ||
          "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
        title: "ASSOCHAM Health & Wellness Excellence Awards",
      },
    ],
  },
  {
    id: "illness-to-wellness-elders",
    title: "Illness to Wellness Interactive Session on Empowering Elders",
    cat: "Education & Health",
    date: "June 10, 2025",
    location: "New Delhi",
    description:
      "Holistic eldercare healthcare frameworks, geriatric insurance, and community wellness programs for senior citizens of Bharat.",
    banner:
      IMG?.edu1 ||
      "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
    photos: [
      {
        src:
          IMG?.edu1 ||
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
        title: "Special Address by Eminent Medical Practitioners & Geriatricians",
      },
      {
        src:
          IMG?.conf2 ||
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
        title: "Interactive Open Q&A Session with Senior Citizen Delegates",
      },
      {
        src:
          IMG?.conf3 ||
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
        title: "Felicitation of Wellness & Eldercare NGO Volunteers",
      },
    ],
  },
];

const CATEGORIES = [
  "All",
  "Conferences",
  "Policy & Governance",
  "Industry & MSME",
  "Sustainability & ESG",
  "Finance & Markets",
  "Education & Health",
];

export default function ImageLibrary() {
  const [cat, setCat] = useState("All");
  const [query, setQuery] = useState("");

  // Currently open Event Album
  const [activeAlbum, setActiveAlbum] = useState(null);

  // Currently open Single Photo in Lightbox
  const [lightboxImage, setLightboxImage] = useState(null);

  // Filtered Events
  const filteredEvents = useMemo(() => {
    return EVENT_ALBUMS.filter((evt) => {
      const matchesCat = cat === "All" || evt.cat === cat;
      const matchesQuery =
        evt.title.toLowerCase().includes(query.trim().toLowerCase()) ||
        evt.location.toLowerCase().includes(query.trim().toLowerCase()) ||
        evt.description.toLowerCase().includes(query.trim().toLowerCase());
      return matchesCat && matchesQuery;
    });
  }, [cat, query]);

  function Breadcrumb({ label }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
        <li>
          <a
            href="/"
            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li>
          <a href="/knowledge" className="transition-colors duration-300 hover:text-[#DA2128]">
            News Room
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">Image Library</li>
      </ol>
    </nav>
  );
}

  return (
    <main className="min-h-screen bg-cream text-ink">
      {/* ================= HERO SECTION ================= */}
      <section className="relative overflow-hidden bg-blush">
        <div className="absolute inset-0 dot-grid opacity-70" />
        <div className="absolute -top-24 -right-24 w-[380px] h-[380px] rounded-full bg-gradient-to-bl from-brand/15 to-ember/10 blur-3xl pointer-events-none" />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-12 pb-16 sm:pt-16">
          <Breadcrumb />

          {/* <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-white ring-1 ring-brand/20 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.2em] text-deeprose shadow-sm"
          >
            <ImageIcon className="w-3.5 h-3.5 text-ember" /> Official Indian Event Albums
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 }}
            className="mt-5 font-display font-bold text-[38px] sm:text-[52px] leading-[1.08] tracking-tight text-ink"
          >
            ASSOCHAM India{" "}
            <em className="italic text-transparent bg-clip-text bg-gradient-to-r from-crimson via-brand to-ember">
              Photo Gallery & Archives
            </em>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.16 }}
            className="mt-4 text-[15px] text-ink/65 max-w-2xl font-medium leading-relaxed"
          >
            Explore official photo albums from ASSOCHAM national conclaves, ministerial
            roundtables, and industry summits across India. Click on any event card to open its
            complete high-resolution photo gallery.
          </motion.p> */}
        </div>
      </section>

      {/* ================= FILTER & SEARCH BAR ================= */}
      <section className="py-7 border-b border-ink/5 bg-white/80 backdrop-blur-md sticky top-0 z-30 shadow-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between gap-4">
            {/* Category Pills */}
            {/* <div className="flex flex-wrap gap-2">
              {CATEGORIES.map((c) => (
                <button
                  key={c}
                  onClick={() => setCat(c)}
                  className={`px-4 py-2 rounded-full text-[12px] font-extrabold ring-1 transition-all ${
                    cat === c
                      ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent shadow-md shadow-brand/25"
                      : "bg-white text-ink/70 ring-ink/15 hover:ring-brand hover:text-brand"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div> */}

            {/* Search Input */}
            <div className="relative w-full sm:w-72">
              <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-mute" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search event title or city..."
                className="w-full rounded-xl bg-white ring-1 ring-ink/15 focus:ring-2 focus:ring-brand outline-none py-2.5 pl-10 pr-9 text-[13px] font-semibold transition-shadow"
              />
              {query && (
                <button
                  onClick={() => setQuery("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-mute hover:text-ink"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ================= EVENT ALBUM CARDS GRID ================= */}
      <section className="py-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <AnimatePresence mode="popLayout">
            {filteredEvents.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredEvents.map((evt, index) => (
                  <motion.div
                    layout
                    key={evt.id}
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.35, delay: index * 0.03 }}
                    onClick={() => setActiveAlbum(evt)}
                    className="group cursor-pointer rounded-3xl bg-white overflow-hidden ring-1 ring-ink/10 hover:ring-brand/40 shadow-sm hover:shadow-xl hover:shadow-brand/10 transition-all duration-300 flex flex-col"
                  >
                    {/* Banner Image */}
                    <div className="relative aspect-[16/10] overflow-hidden bg-ink/10">
                      <img
                        src={evt.banner}
                        alt={evt.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      {/* Gradient Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-[#100806]/80 via-[#100806]/20 to-transparent" />

                      {/* Top Badges */}
                      <div className="absolute top-4 inset-x-4 flex items-center justify-between gap-2">
                        <span className="rounded-full bg-white/95 backdrop-blur-md px-3 py-1 text-[10px] font-extrabold uppercase tracking-wider text-brand shadow-sm">
                          {evt.cat}
                        </span>

                        <span className="inline-flex items-center gap-1.5 rounded-full bg-black/65 backdrop-blur-md px-3 py-1 text-[11px] font-bold text-white shadow-sm">
                          <Layers className="w-3 h-3 text-ember" />
                          {evt.photos.length} Photos
                        </span>
                      </div>

                      {/* Date & Location */}
                      <div className="absolute bottom-4 inset-x-4 flex items-center gap-3 text-white/95 text-[12px] font-semibold">
                        <span className="inline-flex items-center gap-1">
                          <Calendar className="w-3.5 h-3.5 text-ember" />
                          {evt.date}
                        </span>
                        <span>•</span>
                        <span className="inline-flex items-center gap-1">
                          <MapPin className="w-3.5 h-3.5 text-ember" />
                          {evt.location}
                        </span>
                      </div>
                    </div>

                    {/* Card Body */}
                    <div className="p-6 flex-1 flex flex-col justify-between">
                      <div>
                        <h3 className="font-display font-bold text-[17px] sm:text-[19px] text-ink leading-snug group-hover:text-brand transition-colors line-clamp-2">
                          {evt.title}
                        </h3>
                        <p className="mt-2 text-[13.5px] text-ink/65 line-clamp-2 leading-relaxed font-normal">
                          {evt.description}
                        </p>
                      </div>

                      {/* View Album Link */}
                      <div className="mt-6 pt-4 border-t border-ink/10 flex items-center justify-between text-brand font-bold text-[13px]">
                        <span className="inline-flex items-center gap-1.5 group-hover:underline">
                          <Eye className="w-4 h-4" /> View Event Album
                        </span>
                        <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="py-20 text-center">
                <p className="text-[16px] text-mute font-bold">
                  No ASSOCHAM India events found matching “{query}” in category “{cat}”.
                </p>
              </div>
            )}
          </AnimatePresence>
        </div>
      </section>

      {/* ==================================================================== */}
      {/* ============= EVENT ALBUM MODAL (Z-INDEX 99999 FIXED) ============== */}
      {/* ==================================================================== */}
      <AnimatePresence>
        {activeAlbum && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[99999] bg-[#100806]/90 backdrop-blur-md overflow-y-auto"
          >
            {/* STICKY HEADER BAR IN MODAL SO CLOSE BUTTON IS NEVER CUT OFF OR OVERLAPPED */}
            <div className="sticky top-0 z-50 bg-white border-b border-ink/15 shadow-md">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-4">
                <button
                  onClick={() => setActiveAlbum(null)}
                  className="inline-flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-wider text-brand hover:text-crimson transition-colors"
                >
                  <ArrowLeft className="w-4 h-4" /> Back to Event Library
                </button>

                <button
                  onClick={() => setActiveAlbum(null)}
                  className="inline-flex items-center gap-2 px-5 py-2 rounded-xl bg-gradient-to-r from-crimson to-deeprose text-white text-[13px] font-bold shadow-md shadow-brand/20 hover:brightness-105 transition"
                >
                  <X className="w-4 h-4" /> Close Album
                </button>
              </div>
            </div>

            {/* ALBUM CONTENT */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
              {/* Event Info Box */}
              {/* <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl mb-8">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                  <div>
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-brand/10 text-brand px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider mb-3">
                      <Sparkles className="w-3.5 h-3.5" /> {activeAlbum.cat}
                    </span>
                    <h2 className="font-display font-bold text-[24px] sm:text-[32px] text-ink leading-tight">
                      {activeAlbum.title}
                    </h2>
                    <div className="mt-3 flex flex-wrap items-center gap-4 text-[13.5px] font-semibold text-mute">
                      <span className="inline-flex items-center gap-1.5 text-ink">
                        <Calendar className="w-4 h-4 text-brand" /> {activeAlbum.date}
                      </span>
                      <span>•</span>
                      <span className="inline-flex items-center gap-1.5 text-ink">
                        <MapPin className="w-4 h-4 text-brand" /> {activeAlbum.location}, Bharat
                      </span>
                    </div>
                  </div>
                </div>

                <p className="mt-4 text-[14.5px] text-ink/75 max-w-4xl leading-relaxed">
                  {activeAlbum.description} All photographs are cleared for editorial and press
                  use with credit line <strong className="text-ink font-bold">“Photo: ASSOCHAM”</strong>.
                </p>
              </div> */}

              {/* Event Photos Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {activeAlbum.photos.map((photo, idx) => (
                  <motion.div
                    key={photo.src + idx}
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: idx * 0.04 }}
                    onClick={() =>
                      setLightboxImage({
                        ...photo,
                        cat: activeAlbum.cat,
                        eventTitle: activeAlbum.title,
                      })
                    }
                    className="group relative cursor-pointer rounded-2xl overflow-hidden bg-ink/10 aspect-[4/3] shadow-lg ring-1 ring-white/15 hover:ring-brand"
                  >
                    <img
                      src={photo.src}
                      alt={photo.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#100806]/95 via-[#100806]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                    {/* Photo Title on Hover */}
                    <div className="absolute inset-x-0 bottom-0 p-5 translate-y-3 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                      <p className="text-white text-[14px] font-bold leading-snug">
                        {photo.title}
                      </p>
                      <p className="text-ember text-[10px] font-extrabold uppercase tracking-[0.16em] mt-1">
                        Click to zoom & download
                      </p>
                    </div>

                    <span className="absolute top-3 right-3 w-9 h-9 rounded-xl grid place-items-center bg-white/90 text-brand opacity-0 group-hover:opacity-100 transition-opacity shadow-md">
                      <ZoomIn className="w-4 h-4" />
                    </span>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ==================================================================== */}
      {/* ============= LIGHTBOX MODAL (Z-INDEX 999999 FOR ZOOM) ============= */}
      {/* ==================================================================== */}
      <AnimatePresence>
        {lightboxImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[999999] bg-[#0c0604]/95 backdrop-blur-md grid place-items-center p-4 sm:p-8"
            onClick={() => setLightboxImage(null)}
          >
            <motion.figure
              initial={{ scale: 0.92, y: 24 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.92, y: 24 }}
              transition={{ type: "spring", stiffness: 260, damping: 26 }}
              className="relative max-w-5xl w-full rounded-3xl overflow-hidden bg-white shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="relative bg-black max-h-[70vh] flex items-center justify-center overflow-hidden">
                <img
                  src={lightboxImage.src}
                  alt={lightboxImage.title}
                  className="w-full max-h-[70vh] object-contain"
                />
              </div>

              <figcaption className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-6 bg-white">
                <div>
                  <p className="font-display font-bold text-[18px] text-ink">
                    {lightboxImage.title}
                  </p>
                  <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-ember mt-1">
                    {lightboxImage.eventTitle} • Photo: ASSOCHAM
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <a
                    href={lightboxImage.src}
                    target="_blank"
                    rel="noreferrer"
                    download
                    className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-crimson to-deeprose text-white text-[12px] font-extrabold px-5 py-2.5 shadow-lg shadow-brand/25 hover:brightness-105 transition"
                  >
                    <Download className="w-3.5 h-3.5" /> Download Full Size
                  </a>
                  <button
                    onClick={() => setLightboxImage(null)}
                    className="w-10 h-10 rounded-xl grid place-items-center ring-1 ring-ink/15 text-ink/70 hover:text-brand hover:ring-brand transition-all"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              </figcaption>
            </motion.figure>
          </motion.div>
        )}
      </AnimatePresence>
    </main>
  );
}